import PopularOrganizationTranscriptsReducer from './PopularOrganizationTranscriptsReducer';

export default from './PopularOrganizationTranscriptsContainer';

export const PopularOrganizationTranscriptsReducers = {
  PopularOrganizationTranscriptsReducer,
};
